import { Box, IconButtonProps } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import { ReactNode } from 'react';

import {
  InstructionButton,
  InstructionDialog,
} from '~/components/Instructions';
import {
  InstructionDialogConfig,
  useInstructionDialog,
} from '~/components/Instructions/useInstructionDialog';
import { useSxStyles } from '~/components/SolaForceHeading/useStyles';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = {
  heading?: string;
  headingIcon?: ReactNode;
  children?: ReactNode;
  instruction?: InstructionDialogConfig;
  slotProps?: {
    root?: BoxProps;
    heading?: BoxProps;
    actions?: BoxProps;
    instructionButton?: IconButtonProps;
  };
};

export const SolaForceHeading = (props: PropsType) => {
  const { heading, children, headingIcon, instruction, slotProps } = props;

  const sxStyles = useSxStyles();

  const {
    dialogProps,
    dialogState: { toggle },
    isEnabled,
  } = useInstructionDialog(instruction);

  return (
    <Box
      {...slotProps?.root}
      sx={mergeSxProps(sxStyles.root, slotProps?.root?.sx)}
    >
      {heading && (
        <Box
          {...slotProps?.heading}
          sx={mergeSxProps(sxStyles.heading, slotProps?.heading?.sx)}
        >
          {headingIcon}
          {heading}
          {isEnabled && (
            <InstructionButton
              size={'small'}
              {...slotProps?.instructionButton}
              onClick={(event: React.SyntheticEvent) => {
                event.stopPropagation();
                event.preventDefault();
                toggle();
              }}
            />
          )}
        </Box>
      )}
      <Box
        {...slotProps?.actions}
        sx={mergeSxProps(sxStyles.actions, slotProps?.actions?.sx)}
      >
        {children}
      </Box>
      {isEnabled && <InstructionDialog {...dialogProps} />}
    </Box>
  );
};
